import {JsonApiResponse} from '@tisa-group/cdk';
import {UmpireSeason} from '@tisa-group/models';
import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Observable, tap} from 'rxjs';
import {LoadSeasons, SelectSeason} from '@store/seasons/seasons.actions';
import {SeasonService} from '@tisa-group/core';
import {patch} from '@ngxs/store/operators';

export type SeasonsStateModel = {
  seasons: JsonApiResponse<UmpireSeason[]>;
  selectedSeason: UmpireSeason | undefined;
};
@State<SeasonsStateModel>({
  name: 'seasons',
  defaults: {
    seasons: {data: []},
    selectedSeason: undefined,
  },
})
@Injectable()
export class SeasonsState {
  @Action(LoadSeasons)
  loadSeasons(
    ctx: StateContext<SeasonsStateModel>,
    action: LoadSeasons,
  ): Observable<JsonApiResponse<UmpireSeason[]>> | JsonApiResponse<UmpireSeason[]> {
    if (ctx.getState().seasons.data.length > 0) {
      return ctx.getState().seasons;
    }

    return this.seasonService
      .list(action.params)
      .pipe(tap(seasons => ctx.setState(patch({seasons}))));
  }

  @Action(SelectSeason)
  selectSeason(ctx: StateContext<SeasonsStateModel>, action: SelectSeason): void {
    ctx.setState(patch({selectedSeason: action.season}));
  }

  @Selector()
  static getAvailableSortedSeasons(state: SeasonsStateModel): UmpireSeason[] {
    return state.seasons.data.slice().sort((a, b) => {
      const aName = a.name.split('/')[0];
      const bName = b.name.split('/')[0];

      return aName.localeCompare(bName, undefined, {numeric: true});
    });
  }

  @Selector()
  static getSelectedSeason(state: SeasonsStateModel): UmpireSeason | undefined {
    const currentSeason = state.seasons.data.find(season => season.is_current);

    return state.selectedSeason || currentSeason;
  }

  constructor(readonly seasonService: SeasonService) {}
}
